import { NumericBlurEventArgs } from "@syncfusion/ej2-inputs";

export class Request {
    ID: number = 0;
    Requestcode: string = null;
    Nhapmarequest: string = null;
    Custcode: string = null;
    Custname: string = null;
    //Provincecode: string = null;
    Provincename: string = null;    
    Areaname: string = null;    
    Grouprename: string = null;
    SoCV: string = null;
    NgayCV: Date = null;
    Sohopdong: string = null;
    Sorefnothamchieu: string = null;
    Fromdate: Date = null;
    Todate: Date = null;
    Xacnhan: Boolean = null;
    Noidungxacnhan: string = null;
    Userffmxacnhan: string = null;
    Mauhopdong: string = null;
    Dieukhoanhd: string = null;
    Hieulucbaolanh: string = null;
    Giatribaolanh: string = null;
    Dieukiencan: string = null;
    Mauphuluc: string = null;
    Mauthanhly: string = null;
    Loaihosocungcap: string = null;
    Ngaykyhopdong: Date = null;
    Hieulucketthuc: string = null;
    Ngayguisales: Date = null;
    Ngayhoantathopdong: Date = null;
    UserSC: string = null;
    UserHS: string = null;
    UserFFM: string = null;
    Urgent: Boolean = null;
    DeadlineSCreturn: Date = null;
    DeadlineHScheck: Date = null;
    DeadlineHDdone: Date = null;
    Createdate: Date = null;
    Startdate: Date = null;
    Finishdate: Date = null;
    Active: Boolean = null;
    NoteSC: string = null;
    Tailieukhac: string = null;
    Requestreturn: Boolean = null;
    Idstatus: number = null;
    Idgroupdocument: number = null;
    Idfileattach: number = null;
    Idloaiyeucau: number = null;
    Returnreason: string = null;
    Noidunghopdong: string = null;
    Noidungthanhly: string = null;
    Noidungphuluc: string = null;
    NoteHS: string = null;
    NoteFFM: string = null;
    Nhapmakhapdung: string = null;
    IDstopsanpham: number = null;
    Loaicvkhac: string = null;
    idphanloaithanhly: number = null;
    Yeucauffmxacnhan: Boolean = null;
    Noidunghsxacnhan: string = null;
    Ngayguiketoan: Date = null;
    Info1: string = null;
    Info2: string = null;
    Info3: string = null;
    SCmodified: Date = null;
    Subdistcode: string = null;
    HSModify: Date = null;
    CountReturn: number = null;
    GroupApply: string = null;
    FromRequestCode: string = null;
    NextSteps: string = null;
    DeadlineFFMApproval: Date = null;
    FFMApprovalDate: Date = null;
    HSCheckingDate: Date = null;
    ReturnDate: Date = null;
    PendingDate: Date = null;
    RequestContent: string = null;
    PendingFromDate: Date = null;
    PendingToDate: Date = null;
    RequestTypeDetailId: number = null;
    ContractFormId: number = null;
    PendingReason: string = null;
    RequestStatusName: string = null;
    RequestTypeName: string = null;
    CustObjectList: any[] = [];
    CreatedBy: string = null;
    /*Id: number = 0;
    Id_Link: number = null;
    Area: string = null;
    ApplyFor: string = null;    
    BuyingDate: Date = null;
    ContractEffFrom: Date = null;
    ContractEffTo: Date = null;
    ContractYear: number = null;
    CustAddr3: string = null;
    CustomerCode: string = null;
    CustomerName: string = null;
    CustAddr1: string = null;
    CustAddr2: string = null;
    DistrictCode: string = null;
    LocalGroup1: string = null;
    LocalGroup2: string = null;
    LocalGroup3: string = null;    
    Deadline: Date = null;
    DeadlineApprovalDate: Date = null;
    Detail: string = null;
    Expired: boolean = null;
    FinishedDate: Date = null;
    HasRemind: boolean = null;
    IssuedDate: Date = null;
    LateBuyingDate: number = null;
    Month: number = null;
    MonthResult: number = null;
    No: number = null;
    Notes: string = null;
    Packages: string = null;
    Principal: string = null;
    ReceivedDoc: string = null;
    ReceivingDate: Date = null;
    RefNo: string = null;
    Remind: Date = null;
    SubmittedDate: Date = null;
    TenderEffFrom: Date = null;
    TenderEffTo: Date = null;
    TenderEffectiveness: string = null;
    TenderName: string = null;
    TenderResultDate: Date = null;
    TenderStatus: string = null;
    Year: number = null;
    ApplyCommitment: boolean = null;
    CreatedBy: string = null;
    ModifiedBy: string = null;
    CreatedDate: Date = null;
    ModifiedDate: Date = null;
    DirectOrIndirect: string = null;
    CircularTender: string = null;
    NoOfWinningDoc: string = null;
    TenderLevel: string = null;
    Status: string = null;
    Scope: string = null;
    RefNoPlaining: string = null;
    Asm: string = null;
    Note: string = null;
    ContactPerson: string = null;
    LastRefNo: string = null;
    ProcurementStatus: string = null;
    SampleBox: number = null;
    LocalPartner: string = null;
    TenderLevelName: string = null;
    CircularTenderNew: string = null;*/

    public reset() {
        this.ID = 0;
        this.Requestcode = null;
        this.Nhapmarequest = null;
        this.Custcode = null;
        this.Custname = null;        
        this.Provincename = null;
        this.Areaname = null;
        this.Grouprename = null;
        this.SoCV = null;
        this.NgayCV = null;
        this.Sohopdong = null;
        this.Sorefnothamchieu = null;
        this.Fromdate = null;
        this.Todate = null;
        this.Xacnhan = null;
        this.Noidungxacnhan = null;
        this.Userffmxacnhan = null;
        this.Mauhopdong = null;
        this.Dieukhoanhd = null;
        this.Hieulucbaolanh = null;
        this.Giatribaolanh = null;
        this.Dieukiencan = null;
        this.Mauphuluc = null;
        this.Mauthanhly = null;
        this.Loaihosocungcap = null;
        this.Ngaykyhopdong = null;
        this.Hieulucketthuc = null;
        this.Ngayguisales = null;
        this.Ngayhoantathopdong = null;
        this.UserSC = null;
        this.UserHS = null;
        this.UserFFM = null;
        this.Urgent = null;
        this.DeadlineSCreturn = null;
        this.DeadlineHScheck = null;
        this.DeadlineHDdone = null;
        this.Createdate = null;
        this.Startdate = null;
        this.Finishdate = null;
        this.Active = null;
        this.NoteSC = null;
        this.Tailieukhac = null;
        this.Requestreturn = null;
        this.Idstatus = null;
        this.Idgroupdocument = null;
        this.Idfileattach = null;
        this.Idloaiyeucau = null;
        this.Returnreason = null;
        this.Noidunghopdong = null;
        this.Noidungthanhly = null;
        this.Noidungphuluc = null;
        this.NoteHS = null;
        this.NoteFFM = null;
        this.Nhapmakhapdung = null;
        this.IDstopsanpham = null;
        this.Loaicvkhac = null;
        this.idphanloaithanhly = null;
        this.Yeucauffmxacnhan = null;
        this.Noidunghsxacnhan = null;
        this.Ngayguiketoan = null;
        this.Info1 = null;
        this.Info2 = null;
        this.Info3 = null;
        this.SCmodified = null;
        this.Subdistcode = null;
        this.HSModify = null;
        this.CountReturn = null;
        this.GroupApply = null;
        this.FromRequestCode = null;
        this.NextSteps = null;
        this.DeadlineFFMApproval = null;
        this.FFMApprovalDate = null;
        this.HSCheckingDate = null;
        this.ReturnDate = null;
        this.PendingDate = null;
        this.RequestContent = null;
        this.PendingFromDate = null;
        this.PendingToDate = null;
        this.RequestTypeDetailId = null;
        this.ContractFormId = null;
        this.PendingReason = null;
        this.RequestStatusName = null;
        this.RequestTypeName = null;
        this.CustObjectList = [];
        this.CreatedBy = null;
        /*this.Id = 0;
        this.Id_Link = null;
        this.ApplyFor = null;
        this.Area = null;
        this.BuyingDate = null;
        this.ContractEffFrom = null;
        this.ContractEffTo = null;
        this.ContractYear = null;
        this.CustAddr3 = null;
        this.CustomerCode = null;
        this.CustomerName = null;
        this.CustAddr1 = null;
        this.CustAddr2 = null;
        this.DistrictCode = null;
        this.LocalGroup1 = null;
        this.LocalGroup2 = null;
        this.LocalGroup3 = null;                
        this.Deadline = null;
        this.DeadlineApprovalDate = null;
        this.Detail = null;
        this.Expired = null;
        this.FinishedDate = null;
        this.HasRemind = null;
        this.IssuedDate = null;
        this.LateBuyingDate = null;
        this.Month = null;
        this.MonthResult = null;
        this.No = null;
        this.Notes = null;
        this.Packages = null;
        this.Principal = null;
        this.ReceivedDoc = null;
        this.ReceivingDate = null;
        this.RefNo = null;
        this.Remind = null;
        this.SubmittedDate = null;
        this.TenderEffFrom = null;
        this.TenderEffTo = null;
        this.TenderEffectiveness = null;
        this.TenderName = null;
        this.TenderResultDate = null;
        this.TenderStatus = null;
        this.Year = null;
        this.ApplyCommitment = null;
        this.CreatedBy = null;
        this.ModifiedBy = null;
        this.CreatedDate = null;
        this.ModifiedDate = null;
        this.DirectOrIndirect = null;
        this.CircularTender = null;
        this.NoOfWinningDoc = null;
        this.TenderLevel = null;
        this.Status = null;
        this.Scope = null;
        this.RefNoPlaining = null;
        this.Asm = null;
        this.Note = null;
        this.ContactPerson = null;
        this.LastRefNo = null;
        this.ProcurementStatus = null;
        this.SampleBox = null;
        this.LocalPartner = null;
        this.TenderLevelName = null;
        this.CircularTenderNew = null;*/

    }

    public set(p: any) {
        //console.log('chip1');
        this.ID = p.ID;
        this.Requestcode = p.Requestcode;
        this.Nhapmarequest = p.Nhapmarequest;
        this.Custcode = p.Custcode;
        this.Custname = p.Custname;
        //this.Provincecode = p.Provincecode;
        this.Provincename = p.Provincename;
        this.Areaname = p.Areaname;
        this.Grouprename = p.Grouprename;
        this.SoCV = p.SoCV;
        this.NgayCV = p.NgayCV;
        this.Sohopdong = p.Sohopdong;
        this.Sorefnothamchieu = p.Sorefnothamchieu;
        this.Fromdate = p.Fromdate;
        this.Todate = p.Todate;
        this.Xacnhan = p.Xacnhan;
        this.Noidungxacnhan = p.Noidungxacnhan;
        this.Userffmxacnhan = p.Userffmxacnhan;
        this.Mauhopdong = p.Mauhopdong;
        this.Dieukhoanhd = p.Dieukhoanhd;
        this.Hieulucbaolanh = p.Hieulucbaolanh;
        this.Giatribaolanh = p.Giatribaolanh;
        this.Dieukiencan = p.Dieukiencan;
        this.Mauphuluc = p.Mauphuluc;
        this.Mauthanhly = p.Mauthanhly;
        this.Loaihosocungcap = p.Loaihosocungcap;
        this.Ngaykyhopdong = p.Ngaykyhopdong;
        this.Hieulucketthuc = p.Hieulucketthuc;
        this.Ngayguisales = p.Ngayguisales;
        this.Ngayhoantathopdong = p.Ngayhoantathopdong;
        this.UserSC = p.UserSC;
        this.UserHS = p.UserHS;
        this.UserFFM = p.UserFFM;
        this.Urgent = p.Urgent;
        this.DeadlineSCreturn = p.DeadlineSCreturn;
        this.DeadlineHScheck = p.DeadlineHScheck;
        this.DeadlineHDdone = p.DeadlineHDdone;
        this.Createdate = p.Createdate;
        this.Startdate = p.Startdate;
        this.Finishdate = p.Finishdate;
        this.Active = p.Active;
        this.NoteSC = p.NoteSC;
        this.Tailieukhac = p.Tailieukhac;
        this.Requestreturn = p.Requestreturn;
        this.Idstatus = p.Idstatus;
        this.Idgroupdocument = p.Idgroupdocument;
        this.Idfileattach = p.Idfileattach;
        this.Idloaiyeucau = p.Idloaiyeucau;
        this.Returnreason = p.Returnreason;
        this.Noidunghopdong = p.Noidunghopdong;
        this.Noidungthanhly = p.Noidungthanhly;
        this.Noidungphuluc = p.Noidungphuluc;
        this.NoteHS = p.NoteHS;
        this.NoteFFM = p.NoteFFM;
        this.Nhapmakhapdung = p.Nhapmakhapdung;
        this.IDstopsanpham = p.IDstopsanpham;
        this.Loaicvkhac = p.Loaicvkhac;
        this.idphanloaithanhly = p.idphanloaithanhly;
        this.Yeucauffmxacnhan = p.Yeucauffmxacnhan;
        this.Noidunghsxacnhan = p.Noidunghsxacnhan;
        this.Ngayguiketoan = p.Ngayguiketoan;
        this.Info1 = p.Info1;
        this.Info2 = p.Info2;
        this.Info3 = p.Info3;
        this.SCmodified = p.SCmodified;
        this.Subdistcode = p.Subdistcode;
        this.HSModify = p.HSModify;
        this.CountReturn = p.CountReturn;
        this.GroupApply = p.GroupApply;
        this.FromRequestCode = p.FromRequestCode;
        this.NextSteps = p.NextSteps;
        this.DeadlineFFMApproval = p.DeadlineFFMApproval;
        this.FFMApprovalDate = p.FFMApprovalDate;
        this.HSCheckingDate = p.HSCheckingDate;
        this.ReturnDate = p.ReturnDate;
        this.PendingDate = p.PendingDate;
        this.RequestContent = p.RequestContent;
        this.PendingFromDate = p.PendingFromDate;
        this.PendingToDate = p.PendingToDate;
        this.RequestTypeDetailId = p.RequestTypeDetailId;
        this.ContractFormId = p.ContractFormId;
        this.PendingReason = p.PendingReason;
        this.RequestStatusName = p.RequestStatusName;
        this.RequestTypeName = p.RequestTypeName;
        this.CreatedBy = p.CreatedBy;
        /*this.Id = p.Id;
        this.Id_Link = p.Id_Link;
        this.ApplyFor = p.ApplyFor;
        this.Area = p.Area;
        this.BuyingDate = p.BuyingDate;
        this.ContractEffFrom = p.ContractEffFrom;
        this.ContractEffTo = p.ContractEffTo;
        this.ContractYear = p.ContractYear;
        this.CustAddr3 = p.CustAddr3;
        this.CustomerCode = p.CustomerCode;
        this.CustomerName = p.CustomerName;
        this.CustAddr1 = p.CustAddr1;
        this.CustAddr2 = p.CustAddr2;
        this.DistrictCode = p.DistrictCode;
        this.LocalGroup1 = p.LocalGroup1;
        this.LocalGroup2 = p.LocalGroup2;
        this.LocalGroup3 = p.LocalGroup3;        
        this.Deadline = p.Deadline;
        this.DeadlineApprovalDate = p.DeadlineApprovalDate;
        this.Detail = p.Detail;
        this.Expired = p.Expired;
        this.FinishedDate = p.FinishedDate;
        this.HasRemind = p.HasRemind;
        this.IssuedDate = p.IssuedDate;
        this.LateBuyingDate = p.LateBuyingDate;
        this.Month = p.Month;
        this.MonthResult = p.MonthResult;
        this.No = p.No;
        this.Notes = p.Notes;
        this.Packages = p.Packages;
        this.Principal = p.Principal;
        this.ReceivedDoc = p.ReceivedDoc;
        this.ReceivingDate = p.ReceivingDate;
        this.RefNo = p.RefNo;
        this.Remind = p.Remind;
        this.SubmittedDate = p.SubmittedDate;
        this.TenderEffFrom = p.TenderEffFrom;
        this.TenderEffTo = p.TenderEffTo;
        this.TenderEffectiveness = p.TenderEffectiveness;
        this.TenderName = p.TenderName;
        this.TenderResultDate = p.TenderResultDate;
        this.TenderStatus = p.TenderStatus;
        this.Year = p.Year;
        this.ApplyCommitment = p.ApplyCommitment;
        this.CreatedBy = p.CreatedBy;
        this.ModifiedBy = p.ModifiedBy;
        this.CreatedDate = p.CreatedDate;
        this.ModifiedDate = p.ModifiedDate;
        this.DirectOrIndirect = p.DirectOrIndirect;
        this.CircularTender = p.CircularTender;
        this.NoOfWinningDoc = p.NoOfWinningDoc;
        this.TenderLevel = p.TenderLevel;
        this.Status = p.Status;
        this.Scope = p.Scope;
        this.RefNoPlaining = p.RefNoPlaining;
        this.Asm = p.Asm;
        this.Note = p.Note;
        this.ContactPerson = p.ContactPerson;
        this.LastRefNo = p.LastRefNo;
        this.ProcurementStatus = p.ProcurementStatus;
        this.SampleBox = p.SampleBox;
        this.LocalPartner = p.LocalPartner;
        this.TenderLevelName = p.TenderLevelName;
        this.CircularTenderNew = p.CircularTenderNew;*/

        //console.log('chip2');
    }
}
